"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = exports.addSelections = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var useUniqueID_1 = require("../utils/useUniqueID");
var useDescribers_1 = require("../utils/useDescribers");
var Help_1 = require("../InputModules/Help");
var InputBottomRow_1 = require("../InputModules/InputBottomRow");
var SelectModules_1 = require("../SelectModules");
var utils_1 = require("../SelectModules/utils");
var shared_1 = require("../shared");
var helperFunctions_1 = require("../utils/helperFunctions");
var selectInputContainerStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: relative;\n"], ["\n  box-sizing: border-box;\n  position: relative;\n"])));
/**
 * Add new items when `value` prop updates, verifying
 * new items don't already exist as selected items
 * @param safelyCallItemToID - function to convert item to ID
 * @param addSelectedItem - adds item to MultiSelect, derived from `useMultipleSelection` hook
 * @param newItems - array of newly selected items
 * @param selectedItems - array of currently selected items
 */
var addSelections = function (safelyCallItemToID, addSelectedItem, newItems, selectedItems) {
    if (selectedItems === void 0) { selectedItems = []; }
    var itemToID = safelyCallItemToID;
    var selectedItemIds = selectedItems.map(function (item) { return itemToID(item); });
    newItems
        .filter(function (newItem) { return !selectedItemIds.includes(itemToID(newItem)); })
        .forEach(function (newItem) { return addSelectedItem(newItem); });
};
exports.addSelections = addSelections;
var MultiSelect = function (_a) {
    var AllowCreateProps = _a.AllowCreateProps, allowItemTextWrap = _a.allowItemTextWrap, ariaLabel = _a["aria-label"], className = _a.className, customRender = _a.customRender, error = _a.error, guidance = _a.guidance, help = _a.help, id = _a.id, inputHeight = _a.inputHeight, _b = _a.initialSelectedItems, initialSelectedItems = _b === void 0 ? [] : _b, innerInputRef = _a.innerInputRef, innerWrapperRef = _a.innerWrapperRef, isAsync = _a.isAsync, isDisabled = _a.isDisabled, isLoading = _a.isLoading, isRequired = _a.isRequired, itemIsAnchored = _a.itemIsAnchored, itemIsDisabled = _a.itemIsDisabled, _c = _a.items, items = _c === void 0 ? [] : _c, itemToID = _a.itemToID, itemToString = _a.itemToString, label = _a.label, listboxWidth = _a.listboxWidth, maxHeight = _a.maxHeight, onBlur = _a.onBlur, onChange = _a.onChange, onInputChange = _a.onInputChange, onInternalStateChange = _a.onInternalStateChange, onListboxScroll = _a.onListboxScroll, placeholder = _a.placeholder, placeholderTag = _a.placeholderTag, shouldShowAdditionalResultsMessage = _a.shouldShowAdditionalResultsMessage, showClearAllIcon = _a.showClearAllIcon, style = _a.style, testId = _a.testId, units = _a.units, useCheckboxSelection = _a.useCheckboxSelection, value = _a.value, props = __rest(_a, ["AllowCreateProps", "allowItemTextWrap", 'aria-label', "className", "customRender", "error", "guidance", "help", "id", "inputHeight", "initialSelectedItems", "innerInputRef", "innerWrapperRef", "isAsync", "isDisabled", "isLoading", "isRequired", "itemIsAnchored", "itemIsDisabled", "items", "itemToID", "itemToString", "label", "listboxWidth", "maxHeight", "onBlur", "onChange", "onInputChange", "onInternalStateChange", "onListboxScroll", "placeholder", "placeholderTag", "shouldShowAdditionalResultsMessage", "showClearAllIcon", "style", "testId", "units", "useCheckboxSelection", "value"]);
    (0, helperFunctions_1.validateInputLabelAccessibility)('MultiSelect', label, ariaLabel);
    var dropdownWrapperRef = (0, react_1.useRef)(null);
    var multiSelectInnerInputRef = (0, react_1.useRef)(null);
    var selectInputMultiSelectRef = innerInputRef || multiSelectInnerInputRef;
    var uniqueIdMultiSelect = (0, useUniqueID_1.useUniqueId)(id);
    var describersMultiSelect = (0, useDescribers_1.useDescribers)({ help: help, uniqueId: uniqueIdMultiSelect, guidance: guidance });
    var renderItemToStringMultiSelect = itemToString || utils_1.determineItemValue;
    var _d = (0, utils_1.useDetermineFilteredListItems)(useCheckboxSelection), filteredAnchoredItemsCount = _d.filteredAnchoredItemsCount, listItems = _d.listItems, updateFilteredListboxItems = _d.updateFilteredListboxItems, setListItems = _d.setListItems;
    var updateFilteredItemsMultiSelect = function (inputText, currentlySelected) {
        if (inputText === void 0) { inputText = inputValue; }
        if (currentlySelected === void 0) { currentlySelected = selectedItems; }
        updateFilteredListboxItems({
            itemIsAnchored: itemIsAnchored,
            items: items,
            itemToID: itemToID,
            renderItemToString: renderItemToStringMultiSelect,
        }, inputText, currentlySelected);
    };
    var clearSelection = function () {
        setSelectedItems([]);
    };
    var safelyCallItemToID = function (item) {
        return (0, utils_1.setupSafelyCallItemToID)(itemToID, renderItemToStringMultiSelect, item);
    };
    var _e = (0, utils_1.useMultiSelectHooks)({
        initialSelectedItems: initialSelectedItems,
        isDisabled: isDisabled,
        itemIsDisabled: itemIsDisabled,
        listItems: listItems,
        onChange: onChange,
        onInputChange: onInputChange,
        onInternalStateChange: onInternalStateChange,
        renderItemToString: renderItemToStringMultiSelect,
        selectInput: selectInputMultiSelectRef,
        updateFilteredItems: updateFilteredItemsMultiSelect,
        safelyCallItemToID: safelyCallItemToID,
    }), useComboboxControlProps = _e.useComboboxControlProps, useMultipleSelectionControlProps = _e.useMultipleSelectionControlProps;
    var getInputProps = useComboboxControlProps.getInputProps, getItemProps = useComboboxControlProps.getItemProps, getLabelProps = useComboboxControlProps.getLabelProps, getMenuProps = useComboboxControlProps.getMenuProps, getToggleButtonProps = useComboboxControlProps.getToggleButtonProps, highlightedIndex = useComboboxControlProps.highlightedIndex, inputValue = useComboboxControlProps.inputValue, isOpen = useComboboxControlProps.isOpen, openMenu = useComboboxControlProps.openMenu;
    var addSelectedItem = useMultipleSelectionControlProps.addSelectedItem, getDropdownProps = useMultipleSelectionControlProps.getDropdownProps, getSelectedItemProps = useMultipleSelectionControlProps.getSelectedItemProps, removeSelectedItem = useMultipleSelectionControlProps.removeSelectedItem, selectedItems = useMultipleSelectionControlProps.selectedItems, setSelectedItems = useMultipleSelectionControlProps.setSelectedItems;
    var isAllowCreate = (0, react_1.useMemo)(function () {
        if (!(AllowCreateProps === null || AllowCreateProps === void 0 ? void 0 : AllowCreateProps.allowCreate) || !inputValue)
            return false;
        if (items.length) {
            var firstItem = items[0];
            if (typeof firstItem === 'string') {
                console.error('AllowCreateProps is not compatible with string items. Please use object items with `id` and `name` properties.');
                return false;
            }
            else if (!Object.prototype.hasOwnProperty.call(firstItem, 'id') ||
                !Object.prototype.hasOwnProperty.call(firstItem, 'name')) {
                console.error('AllowCreateProps is not compatible with items that do not have `id` and `name` properties.');
                return false;
            }
        }
        var isItemExists = listItems.some(function (item) { return item.id.toLowerCase() === inputValue.toLowerCase() && !item.isCreateable; });
        var isItemSelected = selectedItems.some(function (item) { return item.id.toLowerCase() === inputValue.toLowerCase(); });
        return (AllowCreateProps === null || AllowCreateProps === void 0 ? void 0 : AllowCreateProps.allowCreate) && !!inputValue && !isItemExists && !isItemSelected;
    }, [AllowCreateProps === null || AllowCreateProps === void 0 ? void 0 : AllowCreateProps.allowCreate, inputValue, listItems, items, selectedItems]);
    var isCreateExist = (0, react_1.useMemo)(function () { return listItems.some(function (item) { return item.isCreateable; }); }, [listItems]);
    // Add a create item when in allow create
    (0, react_1.useEffect)(function () {
        if (isAllowCreate && !isCreateExist) {
            setListItems(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [
                { id: inputValue, name: inputValue, isCreateable: true },
            ], false); });
        }
    }, [isAllowCreate, listItems, setListItems, inputValue, isCreateExist]);
    // Update items on initial render and when `items` is changed
    (0, react_1.useEffect)(function () {
        if (items.length) {
            updateFilteredItemsMultiSelect(inputValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);
    // If value prop changes, update selection
    (0, react_1.useEffect)(function () {
        if (value) {
            if (value.length > 0) {
                (0, exports.addSelections)(safelyCallItemToID, addSelectedItem, value, selectedItems);
            }
            else if (selectedItems.length > 0) {
                clearSelection();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)(shared_1.inputContainerStyles, selectInputContainerStyles, 'ds-multi-select'), style: style, "data-testid": "".concat(testId, "-container"), ref: innerWrapperRef }, props),
        react_1.default.createElement("div", { className: shared_1.inputTopRowStyles, "data-testid": "".concat(testId, "-top-row") },
            react_1.default.createElement(Help_1.Help, __assign({ id: uniqueIdMultiSelect, testId: testId || uniqueIdMultiSelect }, help))),
        react_1.default.createElement(SelectModules_1.ComboboxInput, { ariaLabel: ariaLabel, uniqueId: uniqueIdMultiSelect, testId: testId || uniqueIdMultiSelect, selectInput: selectInputMultiSelectRef, placeholder: placeholder, openMenu: openMenu, onBlur: onBlur, label: label, itemToString: renderItemToStringMultiSelect, isRequired: isRequired, isOpen: isOpen, isDisabled: isDisabled, getToggleButtonProps: getToggleButtonProps, getSelectedItemProps: getSelectedItemProps, getLabelProps: getLabelProps, getInputProps: getInputProps, error: error, describers: describersMultiSelect, dropdownWrapperRef: dropdownWrapperRef, clearSelection: clearSelection, className: className, inputHeight: inputHeight, inputValue: inputValue || '', multiSelectProps: {
                isMultiSelect: true,
                isRegularMultiSelect: !useCheckboxSelection,
                isCheckboxMultiSelect: useCheckboxSelection,
                getDropdownProps: getDropdownProps,
                selectedItems: selectedItems,
                removeSelectedItem: removeSelectedItem,
                placeholderTag: placeholderTag,
                showClearAllIcon: showClearAllIcon,
            } }),
        react_1.default.createElement(SelectModules_1.ListboxPortal, { AllowCreateProps: AllowCreateProps, totalItemCount: listItems.length, testId: testId || uniqueIdMultiSelect, shouldShowAdditionalResultsMessage: shouldShowAdditionalResultsMessage, onListboxScroll: onListboxScroll, maxHeight: maxHeight, listboxWidth: listboxWidth, itemToString: renderItemToStringMultiSelect, itemToID: itemToID, itemIsDisabled: itemIsDisabled, isOpen: isOpen, isLoading: isLoading, isDisabled: isDisabled, isAsync: isAsync, inputValue: inputValue || '', id: uniqueIdMultiSelect, highlightedIndex: highlightedIndex, getMenuProps: getMenuProps, getItemProps: getItemProps, filteredItems: listItems, filteredAnchoredItemsCount: filteredAnchoredItemsCount, customRender: customRender, dropdownWrapperRef: dropdownWrapperRef, allowItemTextWrap: allowItemTextWrap, selectedItems: selectedItems, useCheckboxSelection: useCheckboxSelection }),
        react_1.default.createElement(InputBottomRow_1.InputBottomRow, { units: units, testId: testId || uniqueIdMultiSelect, isDisabled: isDisabled, id: uniqueIdMultiSelect, guidance: guidance, error: error })));
};
exports.MultiSelect = MultiSelect;
exports.MultiSelect.displayName = 'MultiSelect';
var templateObject_1;
